import { Action, Mutation } from "../types";
//import axios from "axios";

export default {
  [Action.LOGIN]({ commit }, authData) {
    return new Promise(resolve => {
      commit(`${[Mutation.LOGIN]}`, authData);
      resolve();
    });
  },
  [Action.LOGOUT]({ commit }) {
    return new Promise(resolve => {
      commit(`${[Mutation.LOGOUT]}`);
      resolve();
    });
  }
};
